import {useMutation} from '@apollo/react-hooks';

import type {
    SetZoomIsEnabled as SetZoomIsEnabledMutation,
    SetZoomIsEnabledVariables as SetZoomIsEnabledMutationVariables,
    SetZoomIsEnabledInput,
    GetZoomIntegration as GetZoomIntegrationQuery,
} from 'nutshell-graphql-types';

import SET_ZOOM_IS_ENABLED from '../mutations/set-zoom-is-enabled.graphql';
import GET_ZOOM_INTEGRATION from '../queries/get-zoom-integration.graphql';

export function useSetZoomIsEnabled(): (arg1: SetZoomIsEnabledInput) => Promise<any> {
    const [setZoomIsEnabled] = useMutation<
        SetZoomIsEnabledMutation,
        SetZoomIsEnabledMutationVariables
    >(SET_ZOOM_IS_ENABLED);

    return (input: SetZoomIsEnabledInput) =>
        setZoomIsEnabled({
            variables: {input},
            update: (proxy, mutationResults) => {
                const cacheResult: GetZoomIntegrationQuery | null | undefined = proxy.readQuery({
                    query: GET_ZOOM_INTEGRATION,
                });

                if (!cacheResult || !cacheResult.loggedInUser) {
                    return;
                }

                const updatedZoomIntegration =
                    mutationResults &&
                    mutationResults.data &&
                    mutationResults.data.setZoomIsEnabled &&
                    mutationResults.data.setZoomIsEnabled.zoomIntegration;

                if (!updatedZoomIntegration) return;

                proxy.writeQuery({
                    query: GET_ZOOM_INTEGRATION,
                    data: {
                        loggedInUser: {
                            ...cacheResult.loggedInUser,
                            zoomIntegration: updatedZoomIntegration,
                        },
                    },
                });
            },
        });
}
